const DEFAULT_CLASSES = {
    base: 'msg-box text-base',
    types: {
        success: 'msg-box--success',
        error: 'msg-box--error',
        alert: 'msg-box--alert',
    },
};

class MessageBox {
    constructor(options = {}) {
        this.target = typeof options.target === 'string'
            ? document.querySelector(options.target)
            : options.target;

        this.position = options.position === 'top' ? 'top' : 'bottom';

        this.baseClass = options.baseClass || DEFAULT_CLASSES.base;
        this.typeClasses = {
            ...DEFAULT_CLASSES.types,
            ...(options.typeClasses || {}),
        };

        this.timeoutId = null;
        this.box = null;
    }

    show(config = {}) {
        if (!this.target) return;

        const {
            type = 'success',
            message = '',
            classes = [],
            timeout = null,
        } = config;

        if (!this.box) {
            this.box = this._createBox();
            this._insertBox();
        }

        this._applyClasses(type, classes);
        this.box.textContent = message;

        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
            this.timeoutId = null;
        }

        if (typeof timeout === 'number' && timeout > 0) {
            this.timeoutId = setTimeout(() => this.hide(), timeout);
        }
    }

    hide() {
        if (this.box && this.box.parentNode) {
            this.box.parentNode.removeChild(this.box);
        }
        this.box = null;

        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
            this.timeoutId = null;
        }
    }

    _createBox() {
        const el = document.createElement('div');
        el.setAttribute('role', 'alert');
        return el;
    }

    _insertBox() {
        if (!this.target || !this.box) return;

        if (this.position === 'top') {
            this.target.insertAdjacentElement('beforebegin', this.box);
        } else {
            this.target.insertAdjacentElement('afterend', this.box);
        }
    }

    _applyClasses(type, extraClasses) {
        if (!this.box) return;

        this.box.className = '';

        const typeClass = this.typeClasses[type] || '';

        const normalize = (value) => {
            if (!value) return [];
            if (Array.isArray(value)) {
                return value
                    .join(' ')
                    .split(/\s+/)
                    .filter(Boolean);
            }
            return String(value)
                .split(/\s+/)
                .filter(Boolean);
        };

        const baseClasses = normalize(this.baseClass);
        const typeClasses = normalize(typeClass);
        const extraTokens = normalize(extraClasses);

        this.box.classList.add(...baseClasses, ...typeClasses, ...extraTokens);
    }

    static showOnce({ target, position, type = 'success', message, classes, timeout }) {
        const instance = new MessageBox({ target, position });
        instance.show({ type, message, classes, timeout });
        return instance;
    }
}

export default MessageBox;
